<template>
  <div id="page-forms">
    <v-container fluid>
      <!-- <app-section-loader :status="loader"></app-section-loader> -->
      <v-form
        v-model="form.valid"
        ref="bomformvalid"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <p> General Informations</p>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm2
          >

            <v-text-field
              label="Date"
              prepend-icon="calendar_today"
              name="date"
              v-model="form.date"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg4
            sm2
          >

            <v-text-field
              label="Login User"
              prepend-icon="person"
              name="user"
              v-model="form.loginUser"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg1
            sm2
          ></v-flex>
          <v-flex
            lg3
            sm2
          >
            <p>
              <v-icon>verified_user</v-icon>&nbsp;&nbsp;Is this your name?
            </p>
            <v-radio-group
              v-model="form.isLogin"
              row
            >
              <v-radio
                label="Yes"
                value="yes-1"
              ></v-radio>
              <v-radio
                @click="authUser"
                label="No"
                value="No-1"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <p>BOM Informations</p>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm2
          >

            <v-text-field
              label="Component For Blister Strip"
              prepend-icon="newspaper"
              name="description"
              v-model="form.blisterComponent"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg4
            sm2
          >

            <v-text-field
              label="Description"
              prepend-icon="line_style"
              name="description"
              v-model="form.description"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg4
            sm2
          >
            <v-text-field
              label="Description 2"
              prepend-icon="subject"
              name="description2"
              v-model="form.description1"
            >
            </v-text-field>

          </v-flex>

          <v-flex
            lg4
            sm2
          >
            <v-text-field
              label="Sub Lot"
              prepend-icon="polymer"
              type="number"
              name="sublot"
              v-model="form.sublot"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm2
          >
            <v-text-field
              label="Batch Size"
              prepend-icon="multiline_chart"
              name="batchSize"
              v-model="form.batchSize"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm2
          >

            <v-autocomplete              
              hint="Atleast 3 Characters required"
              :loading="loader"
              cache-items              
              flat
              placeholder="Select only suggested Pack Size"
              v-model="form.packSize"
              label="Pack Size"
              auto
              chips
              :items="packSizeList"
              prepend-icon="group_work"
              item-text="size"
              item-value="size"
            ></v-autocomplete>

          </v-flex>
          <v-flex
            lg4
            sm2
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"
              :loading="loader"
              cache-items             
              flat
              placeholder="Select only suggested BOM Type"
              v-model="form.bomtype"
              label="BOM Type"
              auto
              chips
              :items="bOMTypeList"
              prepend-icon="drag_indicator"
              required
              item-text="code"
              item-value="code"
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg4
            sm2
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"
              :loading="loader"
              cache-items              
              flat
              placeholder="Select only suggested Unit of Measure Code"
              v-model="form.uom"
              label="Unit of Measure Code"
              :items="UOMList"
              auto
              chips
              prepend-icon="receipt"
              required
              item-text="code"
              item-value="code"
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg4
            sm2
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              cache-items             
              flat
              placeholder="Select only suggested Scrap Unit of Measure"
              v-model="form.scrapUom"
              label="Scrap Unit of Measure"
              auto
              chips
              :items="UOMList"
              prepend-icon="speaker_notes_off"
              required
              item-text="code"
              item-value="code"
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg4
            sm2
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :loading="loader"
              cache-items              
              flat
              placeholder="Select only suggested Scrap Item Code"
              v-model="form.scrapItemCode"
              label="Scrap Item Code"
              auto
              chips
              :items="itemList"
              prepend-icon="speaker_notes_off"
              required
              item-text="description"
              item-value="no"
              :rules="form.requiredfield"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  {{ data.item.no }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.no"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>

          </v-flex>
          <v-flex
            lg4
            sm2
          >

            <v-autocomplete
              v-model="form.statusCodeID"
              label="Status"
              auto
              chips
              prepend-icon="sync"
              :items="statusOptions"
              required
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg12
            sm12
          >
            <blister-scrap-lines ref="scraplineform"></blister-scrap-lines>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>
 <script>
import BlisterScrapLines from '@/pages/scrap/BlisterScrapLines';
import { getBOMType, getUOM, getMachine, getPackSize, getItems } from '@/api/navService';
export default {
  components: {
    BlisterScrapLines
  },

  data: () => ({
    bOMTypeList: [

    ],
    packSizeList: [],
    itemList: [],
    UOMList: [

    ],
    statusOptions: [
      { text: 'New', value: 201 },
      { text: 'Certified', value: 202 },
      { text: 'Under Development', value: 203 },
      { text: 'Closed', value: 204 }
    ],

    items: [
      { title: 'Print' },

    ],
    form: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      blisterScrapId: -1,
      blisterComponent: '',
      description: '',
      description1: '',
      sublot: '',
      batchSize: '',
      packSize: '',
      bomtype: -1,
      uom: -1,
      scrapUom: -1,
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      scrapLines: [],

    },
    loader: false,
  }),
  computed: {
  },
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  created () {
    this.initialize();
  },
  methods: {
    authUser: function () {
      this.$router.push({ path: '/' });
    },
    initialize () {
      this.loader = true;
      getBOMType()
        .then(response => {
          this.bOMTypeList = response.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getPackSize()
        .then(response => {
          this.packSizeList = response.data;
          this.loader = false;
          console.log(response.date);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getUOM()
        .then(response => {
          this.UOMList = response.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getItems()
        .then(response => {
          this.itemList = response.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterStripWeight.vue